import {browserHistory} from 'react-router';
import axios from 'axios';

const baseEndpoint = 'v1/channelcases';

const ChannelCaseService = {

  getCase( id ) {
    return axios
      .get( `${baseEndpoint}/${id}` )
  },

  assignRccs( id, data ) {
    return axios
      .post( `${baseEndpoint}/${id}/rccs/assignees`, data )
  },

  linkRccs( id ) {
    return axios
      .put( `${baseEndpoint}/${id}/rccs/associate` )
  },

  checkIms( id ) {
    return axios
      .get( `${baseEndpoint}/${id}/check/ims` )
  },

  saveCase( data ) {
    return axios
      .post( baseEndpoint, data )
  },
};

export default ChannelCaseService;



// WEBPACK FOOTER //
// ./services/ChannelCaseService.js